import { Storage as AwsStorage } from '@aws-amplify/storage'
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid'

/**
 * Storage
 */
export class Storage {
  /**
   * クラウド上のファイルURL取得.
   * 
   * @param {string} path public以下のファイルパス
   * @returns {string} クラウド上のファイルURL
   */
  static async getFileUrl(path) {
    let url = ''
    path = path.replace(/^public\//g, '')
    const existenceCheck = await AwsStorage.list(path)
    if (existenceCheck.length <= 0) {
      // ファイルない場合の処理はここに書く
    } else {
      url = await AwsStorage.get(path, { level: 'public' })
    }

    return url
  }

  /**
   * クラウド上へファイルアップロード.
   * 
   * @param {string} file アップロードファイル
   * @param {string} dir アップロード先ディレクトリ名
   * @returns {string} アップロードしたファイルパス
   */
  static async uploadFile(file, dir) {
    const key = `${dir}/${dayjs().format('YYYYMMDDHHmmss')}_${uuidv4()}/${file.name}`
    await AwsStorage.put(key, file)
    return key
  }

  /**
   * クラウド上のファイル削除.
   * 
   * @param {string} path public以下のファイルパス
   */
  static async deleteFile(path) {
    path = path.replace(/^public\//g, '')
    await AwsStorage.remove(path, { level: 'public' })
  }

  /**
   * クラウド上のファイルをダウンロード
   * 
   * @param {string} path ダウンロードファイルパス
   * @returns {boolean} true:ダウンロード成功、false:ダウンロード失敗
   */
  static async downloadFile(path) {
    let ret = false

    path = path.replace(/^public\//g, '')
    const existenceCheck = await AwsStorage.list(path)
    if (existenceCheck.length <= 0) {
      ret = false
    } else {
      const url = await AwsStorage.get(path, { level: 'public' })
      if (!window.open(url, "download")) {
        //iOS Safari対応
        const subWindow = window.open()
        subWindow.location.href = url
      }
      ret = true
    }

    return ret
  }
}
